import { render, staticRenderFns } from "./App.vue?vue&type=template&id=47fa0848"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tihomirparushev/Projects/bulgarisation/wp-content/plugins/bulgarisation-for-woocommerce/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fa0848')) {
      api.createRecord('47fa0848', component.options)
    } else {
      api.reload('47fa0848', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=47fa0848", function () {
      api.rerender('47fa0848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/admin/apps/contact-form/components/App.vue"
export default component.exports